/**
 * External dependencies.
 */
import { has, isEmpty } from 'lodash';

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props, selector = false ) {
	const { blockAdvanceOptions } = props.attributes;
	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId }`;

	let styleNormal = '';
	styleNormal += `${ has( blockAdvanceOptions, 'textColor' ) && ! isEmpty( blockAdvanceOptions.textColor ) ? `color: ${ blockAdvanceOptions.textColor };` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'backgroundColor' ) && ! isEmpty( blockAdvanceOptions.backgroundColor ) ? `background: ${ blockAdvanceOptions.backgroundColor };` : '' }`;
	if ( has( blockAdvanceOptions, 'backgroundGradient' ) && ! isEmpty( blockAdvanceOptions.backgroundGradient ) ) {
		styleNormal += `background: ${ blockAdvanceOptions.backgroundGradient };`;
	}
	styleNormal += `${ has( blockAdvanceOptions, 'borderColor' ) && ! isEmpty( blockAdvanceOptions.borderColor ) ? `border-color: ${ blockAdvanceOptions.borderColor };` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'borderWidth' ) && blockAdvanceOptions.borderWidth > 0 ? `border-width: ${ blockAdvanceOptions.borderWidth }px;` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'borderWidth' ) && blockAdvanceOptions.borderWidth > 0 ? `border-style: solid;` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'borderRadius' ) && ! isEmpty( blockAdvanceOptions.borderRadius ) ? `border-radius: ${ blockAdvanceOptions.borderRadius };` : '' }`;

	if ( styleNormal ) {
		css += `${ selector } { ${ styleNormal } }`;
	}

	let styleHover = '';
	styleHover += `${ has( blockAdvanceOptions, 'hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.hoverTextColor ) ? `color: ${ blockAdvanceOptions.hoverTextColor };` : '' }`;
	styleHover += `${ has( blockAdvanceOptions, 'hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundColor ) ? `background: ${ blockAdvanceOptions.hoverBackgroundColor };` : '' }`;
	if ( has( blockAdvanceOptions, 'hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundGradient ) ) {
		styleHover += `background: ${ blockAdvanceOptions.hoverBackgroundGradient };`;
	}
	styleHover += `${ has( blockAdvanceOptions, 'hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.hoverBorderColor };` : '' }`;

	if ( styleHover ) {
		css += `${ selector }:hover { ${ styleHover } }`;
	}

	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}

export default styling;
